import * as v from 'valibot';

export const TenantEditFormSchema = v.object({
    name: v.optional(
        v.pipe(
            v.string(),
            v.trim(),
            v.minLength(2, "Název musí mít alespoň 2 znaky")
        )
    ),
    phone: v.pipe(
        v.string("Telefon je povinný"),
        v.trim(),
        v.minLength(7, "Telefon je příliš krátký"),
        v.maxLength(20, "Telefon je příliš dlouhý")
    ),
    email: v.pipe(
        v.string("E-mail je povinný"),
        v.trim(),
        v.email("Zadejte platný e-mail")
    ),
    url: v.nullable(
        v.pipe(
            v.string(),
            v.trim(),
            v.url("Zadejte platnou URL")
        )
    ),
    firmycz_url: v.nullable(
        v.pipe(
            v.string(),
            v.trim(),
            v.startsWith('https://www.firmy.cz/detail/', 'Musí být adresa firmy.cz'),
        )
    ),
});


export const OrderOfferFormSchema = v.object({
    message: v.pipe(
        v.string(),
        v.trim(),
        v.minLength(10,   "Zpráva musí mít alespoň 10 znaků"),
        v.maxLength(2000, "Zpráva může mít maximálně 2000 znaků")
    ),
    expected_price: v.pipe(
        v.number(),
        v.minValue(0)
    )
});